import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { findDOMNode } from 'react-dom';
import { Avatar, Card } from 'material-ui';
import R from 'ramda';
import GeneralPost from './general';
import MembershipPost from './membership';
import NewProdPublishedPost from './newProdPublished';
import NewLocPublishedPost from './newLocPublished';
import CompNameLoc from '../compNameLoc';
import Timestamp from '../timestamp';
import ActionBar from '../../actionBar/container';
import TCSignUpPost from './tCSignUp';
import {
  getPostForList as getPostForListAction,
  deletePost as deletePostAction,
  updatePost as updatePostAction,
  reportPost,
} from '../../../../stores/newsfeed/actions';
import Linkify from 'react-linkify';
import { parseMessage } from '../../helperFuncs';

import CloudIcon from 'material-ui/svg-icons/file/cloud';
import LoadingBox from './loadingBox';

const propTypes = {
  displayType: PropTypes.string, // internalPostPage, publicPostPage, empty means it's in the list
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  postId: PropTypes.string,
  getPostForList: PropTypes.func,
  deleteAPost: PropTypes.func,
  filterByHashTag: PropTypes.func,
  reportAPost: PropTypes.func,
  body: PropTypes.object,
  viewingCompanyId: PropTypes.string,
  updateAPost: PropTypes.func,
};

class SinglePostContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMoreText: false,
    };
  }

  componentWillMount() {
    const { loaded, postId, getPostForList } = this.props;
    if (!loaded && postId) getPostForList(postId);
  }

  componentWillReceiveProps(nextProps) {
    const { loaded, loading, getPostForList, postId } = nextProps;
    if (!loaded && !loading && postId) getPostForList(postId);
    if (loaded) {
      if (!this.refs.messageDiv || !this.refs.messageOuterDiv) return;
      const messageOuterDiv = findDOMNode(this.refs.messageOuterDiv).offsetHeight;
      const messageDiv = findDOMNode(this.refs.messageDiv).offsetHeight;
      if (messageDiv > messageOuterDiv) {
        this.showMoreText();
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  showMoreText = () => {
    this.setState({ showMoreText: true });
  }

  reportPost = () => {
    const { reportAPost, postId } = this.props;
    const confirm = window.confirm('Are you sure you want to report this post?');
    if (confirm) {
      reportAPost(postId);
    }
  };

  changeRoute = (route) => {
    const { displayType } = this.props;
    const publicPostPage = displayType === 'publicPostPage';
    if (publicPostPage) {
      window.open(`${window.location.protocol}//${window.location.host}/signin?${route}`);
      return;
    }
    this.context.router.push(route);
  };

  render() {
    const { loaded, body, postId, deleteAPost, viewingCompanyId, filterByHashTag, displayType, updateAPost } = this.props;
    if (!loaded) return <LoadingBox/>;
    const parsedMsg = parseMessage(R.pathOr('', ['post', 'message'], body));
    const PostBodyComponent = R.call(R.cond([
      [R.equals('general'), R.always(GeneralPost)],
      [R.equals('new_product'), R.always(NewProdPublishedPost)],
      [R.equals('new_location'), R.always(NewLocPublishedPost)],
      [R.equals('new_membership'), R.always(MembershipPost)],
      [R.equals('tc_new_signup'), R.always(TCSignUpPost)],
      [R.T, R.always(GeneralPost)],
    ]), (body.template || '').toLowerCase());

    const avatarProps = Object.assign({}, body.profileImg ? { src: body.profileImg } : { icon: <CloudIcon style={{ color: '#E0E0E0', fill: '#E0E0E0' }} /> });

    return (
      <div style={{ padding: '0 1px' }}>
        <div style={{ display: 'inline-block', verticalAlign: 'top', padding: '0 5px', width: '11%' }}>
          <Avatar
            className="news-feed-avatar"
            backgroundColor="#ffffff"
            style={{ marginTop: '10px' }}
            {...avatarProps}
          />
        </div>
        <Card style={{ display: 'inline-block', width: '89%', margin: '10px 0', color: 'rgba(0, 0, 0, 0.54)' }}>
          <CompNameLoc
            body={body}
            isOwner={Boolean(viewingCompanyId && body.companyId === viewingCompanyId)}
            displayType={displayType}
            changeRoute={this.changeRoute}
            deleteAPost={() => deleteAPost(postId, body.locations)}
            reportAPost={this.reportPost}
          />
          <div style={{ marginTop: '4px', padding: '0 2%' }}>
            <span style={{ whiteSpace: 'pre-wrap' }}>
              <div ref="messageOuterDiv" style={{ maxHeight: displayType === 'internalPostPage' ? '' : '450px', overflowY: 'hidden' }}>
                <div ref="messageDiv">
              {
                parsedMsg.map(({ type, value }, i) => {
                  if (type === 'string') return (<Linkify properties={{ target: '_blank' }} key={i} >{value}</Linkify>);
                  // FOR HASHTAGS
                  // return <a style={{ cursor: 'pointer' }} key={i} onClick={() => filterByHashTag(value.toLowerCase())}>{value}</a>;
                  return value;
                })
              }
              </div>
              </div>
              {
                this.state.showMoreText &&
                <div
                  style={{
                    minHeight: '35px',
                    display: 'block',
                    position: 'relative',
                    background: 'linear-gradient(to top, rgba(255,255,255, 1) 20%, rgba(255,255,255, 0) 80% )',
                  }}
                  onClick={() => this.changeRoute(`/post/${postId}`)}
                >
                  <span style={{ color: '#00bcd4', cursor: 'pointer', fontSize: '12px', bottom: 0, position: 'absolute' }}>
                    <b>+</b> SEE MORE
                  </span>
                </div>
              }
            </span>
            {
              <PostBodyComponent {...body} changeRoute={this.changeRoute} displayType={displayType} />
            }
          </div>
          <Timestamp timestamp={body.timestamp}/>
          <div style={{ borderTop: '1px solid #ededed', marginTop: '10px' }}>
            <ActionBar
              postId={postId}
              shareableLink={`${window.location.protocol}//${window.location.host}/post/${postId}`}
              companyName={body.companyName}
              message={R.pathOr('', ['post', 'message'], body)}
              updatePost={(updateType) => {
                if (updateType === 'like') {
                  updateAPost(postId, updateType, { numOfLikes: R.inc(R.propOr(0, 'numOfLikes', body)), didUserLike: true });
                } else if (updateType === 'unlike') {
                  updateAPost(postId, updateType, { numOfLikes: R.dec(R.propOr(0, 'numOfLikes', body)), didUserLike: false });
                }
              }}
              numOfLikes={R.propOr(0, 'numOfLikes', body)}
              comments={R.propOr([], 'comments', body)}
              numOfComments={R.propOr(0, 'numOfComments', body)}
              liked={body.didUserLike}
              displayType={displayType}
              changeRoute={this.changeRoute}
              viewingCompanyId={viewingCompanyId}
            />
          </div>
        </Card>
      </div>
    );
  }
}

SinglePostContainer.propTypes = propTypes;

const mapStateToProps = ({ user }) => ({
  viewingCompanyId: user ? user.getIn(['company', 'companyId']) : '',
});

const mapDispatchToProps = dispatch => ({
  getPostForList: (...args) => dispatch(getPostForListAction(...args)),
  deleteAPost: (...args) => dispatch(deletePostAction(...args)),
  updateAPost: (...args) => dispatch(updatePostAction(...args)),
  reportAPost: (postId) => dispatch(reportPost(postId)),
});

SinglePostContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SinglePostContainer);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/postTypes/singlePostContainer.jsx